import React from 'react'

function Header() {
    return (
        <div>

            {/* Navbar Start */}
            <div className="container-fluid sticky-top"
                style={{
                    background: "linear-gradient(90deg, #004aad, #007bff)",
                    borderBottom: "3px solid #003a84",
                    paddingTop: "6px",
                    paddingBottom: "6px"
                }}
            >
                <div className="container">
                    <nav className="navbar navbar-expand-lg navbar-dark p-0">

                        <button type="button" className="navbar-toggler ms-auto me-0" data-bs-toggle="collapse" data-bs-target="#navbarCollapse">
                            <span className="navbar-toggler-icon" />
                        </button>

                        <div className="collapse navbar-collapse justify-content-center" id="navbarCollapse">
                            <div className="navbar-nav">

                                <a href="/index" className="nav-item nav-link" style={navStyle}>Home</a>
                                <a href="/about" className="nav-item nav-link" style={navStyle}>About</a>
                                <a href="/our-team" className="nav-item nav-link" style={navStyle}>Our Team</a>

                                <div className="nav-item dropdown">
                                    <a className="nav-link dropdown-toggle" data-bs-toggle="dropdown" style={navStyle}>Web Development</a>
                                    <div className="dropdown-menu bg-light mt-2">
                                        <a href="/websites" className="dropdown-item">Website Designing</a>
                                        <a href="/eccommerce-websites" className="dropdown-item">E-Commerce Websites</a>
                                        <a href="/customized-websites" className="dropdown-item">Customized Websites</a>
                                    </div>
                                </div>

                                <div className="nav-item dropdown">
                                    <a className="nav-link dropdown-toggle" data-bs-toggle="dropdown" style={navStyle}>Softwares</a>
                                    <div className="dropdown-menu bg-light mt-2">
                                        <a href="/available-softwares" className="dropdown-item">Available Softwares</a>
                                        <a href="/customized-softwares" className="dropdown-item">Customized Softwares</a>
                                    </div>
                                </div>

                                <div className="nav-item dropdown">
                                    <a className="nav-link dropdown-toggle" data-bs-toggle="dropdown" style={navStyle}>Mobile App</a>
                                    <div className="dropdown-menu bg-light mt-2">
                                        <a href="/android-applications" className="dropdown-item">Android Applications</a>
                                        <a href="/ios-applications" className="dropdown-item">IOS Applications</a>
                                        <a href="/customized-applications" className="dropdown-item">Customized Applications</a>
                                    </div>
                                </div>

                                <div className="nav-item dropdown">
                                    <a className="nav-link dropdown-toggle" data-bs-toggle="dropdown" style={navStyle}>Digital Marketing</a>
                                    <div className="dropdown-menu bg-light mt-2">
                                        <a href="/social-media-marketing" className="dropdown-item">Social Media Marketing</a>
                                        <a href="/seo-optimization" className="dropdown-item">SEO Optimization</a>
                                    </div>
                                </div>

                                <a href="/portfolio" className="nav-item nav-link" style={navStyle}>Portfolio</a>
                                <a href="/career" className="nav-item nav-link" style={navStyle}>Career</a>
                                <a href="/contact" className="nav-item nav-link" style={navStyle}>Contact</a>

                            </div>
                        </div>
                    </nav>
                </div>
            </div>
            {/* Navbar End */}

        </div>
    )
}

// 🔥 INLINE Hover + UI Styling
const navStyle = {
    padding: "2px",
    fontWeight: "500",
    transition: "0.3s",
    color: "#fff",
    cursor: "pointer"
}

export default Header
